import { useEffect, useRef, useState, useMemo } from "react";
import Select from 'react-select';
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { TabulatorFull as Tabulator, ColumnComponent, CellComponent } from "tabulator-tables";
import { RequestMethod } from "../modules/services/core/_enums";
import { IGatewaysModel } from "../modules/services/core/_models";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import moment from "moment";

const GatewayTable: React.FC = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const configTableRef = useRef<HTMLDivElement>(null);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const mainTableRef = useRef<any>(null);
  const configTableRefInstance = useRef<any>(null);
  const dataSetNamePBI = getDataSetNamePBI();

  const httpClient = useHttpClient();
  const [listaGateway, setListaGateway] = useState<IGatewaysModel[]>([]);
  const [filteredRowCount, setFilteredRowCount] = useState<number>(0);
  const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>([]);
  const [initialOrganizations, setInitialOrganizations] = useState<string[]>([]);

  async function exportTableToExcel() {

    const tableData = mainTableRef.current.getData();
    console.log("Tabelas:", tableData);
    // Se quiser ver como JSON:
    // console.log("Tabelas: " + JSON.stringify(tableData, null, 2));

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const endpoint = `${backendUrl}/Report/GatewayListExcel`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(tableData)
      });


      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Gateways.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        console.log('Arquivo Excel baixado com sucesso!');
      } else {
        console.error('Erro ao baixar o arquivo Excel:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao fazer o POST:', error);
    }
  }


 const obterListaGateway = async (orgs?: string[]) => {
       try {
         const endpoint = orgs ? '/Gerenciamento/PowerBI/ObterGatewaysByOrg' : '/Gerenciamento/PowerBI/ObterGateways';
         const queryObject = orgs ? { datasetName: dataSetNamePBI, organization: orgs } : { datasetName: dataSetNamePBI };
   
         console.log("Query Object:", queryObject);
   
         const response = await httpClient.request({
           method: RequestMethod.GET,
           endpoint,
           queryObject,
         });
   
         if (response.success && response.payload) {
           setListaGateway(response.payload);
           console.log(response.payload);
           console.log(orgs);
   
           // Atualiza as organizações iniciais somente no primeiro render
           if (initialOrganizations.length === 0) {
             const orgs: string[] = Array.from(new Set(response.payload.map((item: IGatewaysModel) => item.Organizacao)));
             setInitialOrganizations(orgs);
           }
         }
       } catch (error) {
         console.error("Erro ao obter visão geral:", error);
       }
     };

  const loadConfigTable = () => {
    const cols = mainTableRef.current
      .getColumns()
      .map((col: ColumnComponent, index: number) => ({
        id: index + 1,
        title: col.getDefinition().title || col.getField(),
        field: col.getField(),
        visible: col.isVisible(),
      }));

    if (configTableRef.current) {
      if (configTableRefInstance.current) {
        configTableRefInstance.current.destroy();
      }

      configTableRefInstance.current = new Tabulator(configTableRef.current, {
        data: cols,
        layout: "fitDataFill",
        movableRows: true,
        headerVisible: false,
        columns: [
          {
            title: "Mover",
            formatter: "handle",
            headerSort: false,
            width: 30,
            minWidth: 30,
          },
          {
            title: "Coluna",
            field: "title",
            formatter: (cell) => ` ${cell.getValue()}`,
          },
          {
            title: "Visível",
            field: "visible",
            formatter: "tickCross",
            editor: true,
          },
        ],
      });

      // Forçar atualização da tabela principal
      mainTableRef.current.redraw();
    }
  };

  // Funções auxiliares
  const deltaTime = (minutes: number) => {
    const MINUTES_IN_HOUR = 60;
    const HOURS_IN_DAY = 24;
    const DAYS_IN_MONTH = 30;

    const months = Math.floor(minutes / (MINUTES_IN_HOUR * HOURS_IN_DAY * DAYS_IN_MONTH));
    minutes %= MINUTES_IN_HOUR * HOURS_IN_DAY * DAYS_IN_MONTH;

    const days = Math.floor(minutes / (MINUTES_IN_HOUR * HOURS_IN_DAY));
    minutes %= MINUTES_IN_HOUR * HOURS_IN_DAY;

    const hours = Math.floor(minutes / MINUTES_IN_HOUR);
    const remainingMinutes = minutes % MINUTES_IN_HOUR;

    const M = months ? `${months} M, ` : '';
    const D = days ? `${days} d, ` : '';
    const H = hours ? `${hours} h e ` : '';
    const I = `${remainingMinutes} min`;

    return `${M}${D}${H}${I}`;
  };

  // Editor personalizado para filtro de duração
  const durationFilterEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("span");

    const start = document.createElement("input");
    start.setAttribute("type", "number");
    start.setAttribute("placeholder", "Min");
    start.style.padding = "4px";
    start.style.width = "32%";

    const end = start.cloneNode() as HTMLInputElement;
    end.setAttribute("placeholder", "Max");

    const lista = document.createElement('select');
    lista.style.width = "32%";
    lista.style.padding = "2px";

    ['Minutos', 'Horas', 'Dias'].forEach(opt => {
      const option = document.createElement('option');
      option.value = opt.toLowerCase();
      option.text = opt;
      lista.appendChild(option);
    });

    const buildValues = () => {
      success({
        start: start.value,
        end: end.value,
        unit: lista.value
      });
    };

    [start, end, lista].forEach(el => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
    });

    container.appendChild(start);
    container.appendChild(end);
    container.appendChild(lista);

    return container;
  };

  // Editor personalizado para filtro de data
  const dateEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("span");

    // Criar inputs de data
    const date2 = document.createElement("input");
    date2.setAttribute("type", "date");
    date2.style.padding = "3px";
    date2.style.width = "50%";
    date2.style.fontSize = "12px";
    date2.style.boxSizing = "border-box";

    const date1 = date2.cloneNode() as HTMLInputElement;

    // Configurar datas iniciais
    const hoje = new Date();
    date2.value = hoje.toISOString().split('T')[0];

    const dataAnterior = new Date();
    dataAnterior.setFullYear(dataAnterior.getFullYear() - 1);
    date1.value = dataAnterior.toISOString().split('T')[0];

    const buildValues = () => {
      success({
        date1: date1.value,
        date2: date2.value,
      });
    };

    const keypress = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        buildValues();
      }
      if (e.key === "Escape") {
        cancel();
      }
    };

    // Adicionar event listeners
    [date1, date2].forEach(el => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
      el.addEventListener("keydown", keypress);
    });

    container.appendChild(date1);
    container.appendChild(date2);

    return container;
  };

  // Função de filtro para datas
  const dateFilterFunction = (headerValue: any, rowValue: any) => {
    if (!headerValue || (!headerValue.date1 && !headerValue.date2)) return true;
    if (!rowValue) return false;

    // Converter a data da linha do formato DD/MM/YYYY para um objeto Date
    const [day, month, year] = rowValue.split('/');
    const rowDate = new Date(year, month - 1, day);

    // Converter as datas do filtro
    const date1 = headerValue.date1 ? new Date(headerValue.date1) : null;
    const date2 = headerValue.date2 ? new Date(headerValue.date2) : null;

    // Ajustar para o final do dia
    if (date2) {
      date2.setHours(23, 59, 59, 999);
    }

    console.log('Row Date:', rowDate);
    console.log('Date1:', date1);
    console.log('Date2:', date2);

    if (!date1) {
      if (!date2) return true;
      return rowDate <= date2;
    } else {
      if (!date2) return rowDate >= date1;
      return rowDate >= date1 && rowDate <= date2;
    }
  };

  // Adicione este editor personalizado para o filtro de temperatura após a função dateFilterFunction
  const temperatureFilterEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("span");

    const min = document.createElement("input");
    min.setAttribute("type", "number");
    min.setAttribute("placeholder", "Min °C");
    min.style.padding = "4px";
    min.style.width = "48%";
    min.style.marginRight = "4%";

    const max = document.createElement("input");
    max.setAttribute("type", "number");
    max.setAttribute("placeholder", "Max °C");
    max.style.padding = "4px";
    max.style.width = "48%";

    const buildValues = () => {
      success({
        min: min.value ? parseFloat(min.value) : null,
        max: max.value ? parseFloat(max.value) : null,
      });
    };

    [min, max].forEach(el => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
    });

    container.appendChild(min);
    container.appendChild(max);

    return container;
  };

  useEffect(() => {
    if (tableRef.current) {
      mainTableRef.current = new Tabulator(tableRef.current, {
        persistence: true,
        persistenceMode: "local",
        persistenceID: "mainTableRef",
        data: [],
        height: 650,
        layout: "fitData",
        movableColumns: true,
        resizableColumnFit: true,
        columnHeaderVertAlign: "top",
        footerElement: `<div style='color: black'>${listaGateway.length} Gateways carregados (linhas filtradas: ${filteredRowCount})</div>`,
        columns: [
          {
            title: "Organização",
            field: "Organizacao",
            headerFilter: "list",
            headerFilterParams: {
              values: true,
              multiselect: true,
              clearable: true
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
          },
          {
            title: "Local",
            field: "Local",
            headerFilter: "input",
            headerFilterPlaceholder: "Digite para filtrar...",
            headerFilterFunc: "like",
          },
          {
            title: "Local Fixo/Movel",
            field: "PlaceType",
            headerFilter: "list",
            headerFilterParams: {
              values: ["Fixo", "Móvel"],
              multiselect: true,
              clearable: true
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            formatter: (cell: CellComponent) =>
              cell.getValue() === "Fixo"
                ? `<i class='ui icon building'></i> ${cell.getValue()}`
                : `<i class='ui icon car'></i> ${cell.getValue()}`,
          },
          {
            title: "Tempo decorrido",
            field: "TempoDecorrido",
            headerFilter: durationFilterEditor,
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || !headerValue.start) return true;

              const minutes = parseInt(rowValue);
              if (isNaN(minutes)) return false;

              let compareValue = minutes;
              if (headerValue.unit === "horas") {
                compareValue = minutes / 60;
              } else if (headerValue.unit === "dias") {
                compareValue = minutes / (60 * 24);
              }

              const start = parseInt(headerValue.start);
              const end = parseInt(headerValue.end);

              if (start && end) {
                return compareValue >= start && compareValue <= end;
              } else if (start) {
                return compareValue >= start;
              } else if (end) {
                return compareValue <= end;
              }
              return true;
            },
            formatter: (cell: any) => deltaTime(cell.getValue()),
          },
          {
            title: "Gateway",
            field: "Gateway",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: "Buscar gateway...",
            formatter: (cell: CellComponent) => {
              const gateway = cell.getValue();
              return `
                <a href='/detalhes-do-gateway?gateway=${gateway}' target='_blank' style='margin-right: 10px;'>
                  <i class='ui icon external alternate' style='cursor: pointer;'></i>
                </a>
                ${gateway}
              `;
            },
          },
          {
            title: "Descrição do Local",
            field: "LocalDescricao",
            sorter: "string",
          },
          {
            title: "Situação",
            field: "Local Situação",
            headerFilter: "list",
            headerFilterParams: {
              values: ["Habilitado", "Desabilitado"],
              multiselect: true,
              clearable: true
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;

              // Adicionar logs para debug
              console.log('Valor do filtro:', headerValue);
              console.log('Valor da linha:', rowValue);

              // Garantir que a comparação seja parcial e case-insensitive
              const normalizedRowValue = String(rowValue || '').toLowerCase().trim();

              if (Array.isArray(headerValue)) {
                return headerValue.some(val =>
                  normalizedRowValue.startsWith(String(val).toLowerCase().slice(0, 6))
                );
              }

              return normalizedRowValue.startsWith(String(headerValue).toLowerCase().slice(0, 6));
            },
            formatter: (cell: CellComponent) => {
              const value = String(cell.getValue() || '').toLowerCase();
              return value.startsWith('habil')
                ? "<i class='ui green toggle on icon'></i> Habilitado"
                : "<i class='ui red toggle off icon'></i> Desabilitado";
            },
            hozAlign: "center",
          },
          {
            title: "Status",
            field: "Status",
            headerFilter: "list",
            headerFilterParams: {
              values: ["online", "offline"],
              multiselect: true,
              clearable: true
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            formatter: (cell: CellComponent) =>
              cell.getValue() === "online"
                ? "<i class='ui green wifi icon'></i> Online"
                : "<i class='ui red wifi icon'></i> Offline",
            hozAlign: "center",
          },
          {
            title: "Ultima Atualização",
            field: "UltimaAtualizacao",
            headerFilter: dateEditor,
            headerFilterFunc: dateFilterFunction,
            sorter: (a: string, b: string) => {
              // Converter as datas do formato DD/MM/YYYY para objetos Date para comparação
              const [dayA, monthA, yearA] = (a || '').split('/');
              const [dayB, monthB, yearB] = (b || '').split('/');

              const dateA = dayA ? new Date(parseInt(yearA), parseInt(monthA) - 1, parseInt(dayA)) : null;
              const dateB = dayB ? new Date(parseInt(yearB), parseInt(monthB) - 1, parseInt(dayB)) : null;

              if (!dateA && !dateB) return 0;
              if (!dateA) return 1;
              if (!dateB) return -1;

              return dateA.getTime() - dateB.getTime();
            },
            formatter: (cell: any) => {
              const value = cell.getValue();
              if (!value) return " - ";

              // Se o valor já estiver no formato DD/MM/YYYY, retorna ele mesmo
              if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                return value;
              }

              // Caso contrário, tenta formatar
              const date = moment(value);
              return date.isValid() ? date.format("DD/MM/YYYY") : "N/A";
            },
          },
          {
            title: "Temperatura (°C)",
            field: "Temperature",
            sorter: "number",
            headerFilter: temperatureFilterEditor,
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || (!headerValue.min && !headerValue.max)) return true;
              if (!rowValue && rowValue !== 0) return false;

              const value = parseFloat(rowValue);
              const min = headerValue.min !== null ? parseFloat(headerValue.min) : null;
              const max = headerValue.max !== null ? parseFloat(headerValue.max) : null;

              if (min !== null && max !== null) {
                return value >= min && value <= max;
              } else if (min !== null) {
                return value >= min;
              } else if (max !== null) {
                return value <= max;
              }
              return true;
            },
            formatter: (cell: CellComponent) => {
              const value = cell.getValue();
              if (value == null) return " - ";
              const data = value.toFixed(1);
              const temperatura = parseInt(data, 10);
              let temp;

              if (temperatura > 80) {
                temp = `<span><i class="ui icon thermometer full" style="color: #C71585; padding: 2px"></i>${data} ºC</span>`;
              } else if (temperatura > 70 && temperatura < 80) {
                temp = `<span><i class="ui icon thermometer half" style="color: gold; padding: 2px"></i>${data} ºC</span>`;
              } else {
                temp = `<span><i class="ui icon thermometer empty" style="color: aqua; padding: 2px"></i>${data} ºC</span>`;
              }

              return temp;
            },
          },
          {
            title: "Latitude/Longitude",
            field: "Localizacao",
            formatter: (cell: CellComponent) => {
              const data = cell.getRow().getData();
              if (
                data.Latitude &&
                data.Longitude &&
                data.Latitude !== 0 &&
                data.Longitude !== 0
              ) {
                return `
                  <a href='/mapgateway?gateway=${data.Gateway}' target='_blank' style='margin-right: 10px;'>
                    <i class="ui icon map marker alternate"></i>
                  </a>
                  ${data.Latitude}, ${data.Longitude}
                `;
              }
              return `${data.Latitude || " - "}`;
            },
            hozAlign: "center",
          },
        ],
        // Configurações para resolver o warning do wheel event
        tooltipsPassive: true,
        rowContextMenu: false,
        keybindings: false,
        // Outras configurações de performance
        renderVertical: "basic",
        renderHorizontal: "basic",
        virtualDom: true,
        virtualDomHoz: true,
        // Configurações de scroll
        scrollToRowPosition: "top",
        scrollToRowIfVisible: true,
        // Adicionar configuração para eventos passivos
        eventPassive: true
      } as any);
      mainTableRef.current.on("dataLoaded", loadConfigTable);
      mainTableRef.current.on("dataFiltered", (filters: any, rows: any[]) => {
        setFilteredRowCount(rows.length);
      });
    }
  }, []);

  useEffect(() => {
    if (mainTableRef.current) {
      // Atualizar dados da tabela
      mainTableRef.current.replaceData(listaGateway);

      // Atualizar as opções dos filtros dropdown
      const uniqueOrganizacoes = Array.from(new Set(listaGateway.map(item => item.Organizacao)))
        .filter(org => org)
        .sort();

      mainTableRef.current.updateColumnDefinition("Organizacao", {
        headerFilterParams: {
          values: uniqueOrganizacoes,
          multiselect: true,
          clearable: true,
        },
      });
    }
  }, [listaGateway]);

  // Efeito separado para atualizar o footer
  useEffect(() => {
    if (mainTableRef.current) {
      const footerEl = mainTableRef.current.element.querySelector(".tabulator-footer");
      if (footerEl) {
        footerEl.innerHTML = `<div style='color: black'>${listaGateway.length} Gateways carregados (linhas filtradas: ${filteredRowCount})</div>`;
      }
    }
  }, [listaGateway.length, filteredRowCount]);

  // Efeito para carregar dados iniciais
  useEffect(() => {
    obterListaGateway();
  }, []); // Executa apenas uma vez na montagem

  const handleSettingsClick = () => {
    setSidebarVisible(!sidebarVisible);
    if (!sidebarVisible) {
      setTimeout(loadConfigTable, 300);
    }
  };
  const aplicarFiltroOrganizacoes = async (Organizations: string[]) => {
    if (Organizations.length > 0) {
      await obterListaGateway(Organizations);
      console.log(listaGateway);
    } else {
      await obterListaGateway();
    }
    // Forçar a atualização da tabela
    if (mainTableRef.current) {
      mainTableRef.current.replaceData(listaGateway);
    }
  };

  const applyConfigChanges = () => {
    const updatedCols = configTableRefInstance.current.getData();

    const newColumns = updatedCols.map((col: any) => {
      const originalCol = mainTableRef.current.getColumn(col.field);
      if (originalCol) {
        const definition = originalCol.getDefinition();
        return {
          ...definition,
          visible: col.visible,
        };
      }
      return col;
    });

    mainTableRef.current.setColumns(newColumns);
  };

  const handleDownloadCsv = () => {
    mainTableRef.current.download("csv", "gateways.csv");
  };

  // Função para limpar todos os filtros
  const limparFiltros = () => {
    if (mainTableRef.current) {
      try {
        // Limpar todos os filtros
        mainTableRef.current.clearHeaderFilter();

        // Atualizar a contagem de linhas filtradas
        setFilteredRowCount(listaGateway.length);

        // Atualizar o footer
        const footerEl = mainTableRef.current.element.querySelector(".tabulator-footer");
        if (footerEl) {
          footerEl.innerHTML = `<div style='color: black'>${listaGateway.length} Gateways carregados (linhas filtradas: ${listaGateway.length})</div>`;
        }
      } catch (error) {
        console.error("Erro ao limpar filtros:", error);
      }
    }
  };

  return (
    <div className="d-flex" style={{ position: "relative" }}>
      <div style={{ width: sidebarVisible ? "80%" : "100%", transition: "0.3s" }}>
        <h1 className="ui header">Visão Geral</h1>
        <div style={{ marginBottom: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
          {/* Filtro de Organizações */}
          <div style={{ flex: 1, maxWidth: "300px" }}>
            <Select
              isMulti
              options={initialOrganizations.map((org) => ({ label: org, value: org }))}
              onChange={(selectedOptions: any) => {
                const selectedOrgs = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];
                setSelectedOrganizations(selectedOrgs);
                aplicarFiltroOrganizacoes(selectedOrgs);
                console.log(selectedOrgs);
              }}
              placeholder="Filtrar por Organização"
              isClearable
              styles={{
                control: (base: any) => ({
                  ...base,
                  minHeight: "40px",
                  fontSize: "14px",
                }),
                menuPortal: (base: any) => ({ ...base, zIndex: 11000 }),
              }}
            />
          </div>
          {/* Botão de Configurações */}
          <button
            onClick={handleSettingsClick}
            style={{ padding: "10px 20px", cursor: "pointer" }}
            className="ui button primary"
          >
            ⚙️ Configurações
          </button>
          {/* Botão para Limpar Filtros */}
          <button
            onClick={limparFiltros}
            style={{ padding: "10px 20px", cursor: "pointer" }}
            className="ui button secondary"
          >
            🗑️ Limpar Filtros
          </button>
          {/* Botão de Download CSV */}
          <button
            onClick={handleDownloadCsv}
            style={{
              padding: "10px 20px", 
              cursor: "pointer",
              display: "flex", 
              alignItems: "center", 
              gap: "5px", 
            }}
            className="ui button secondary"
          >
            <i className="ui icon arrow alternate circle down outline"></i>
            Download CSV
          </button>
          <button
            onClick={exportTableToExcel}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="ui button secondary"
          >
            <i className="ui icon file excel outline"></i>
            Download Excel
          </button>
        </div>
        {/* Tabela */}
        <div ref={tableRef}></div>
      </div>
      {/* Sidebar de Configurações */}
      {sidebarVisible && (
        <div style={{ width: "20%", backgroundColor: "#f1f1f1", padding: "10px", position: "absolute", right: 0, top: 0, height: "100%", overflowY: "auto", boxShadow: "-2px 0 5px rgba(0,0,0,0.5)" }}>
          <h4 className="ui grey inverted header">
            <i className="ui cog icon"></i> Configurações da Tabela
          </h4>
          <div ref={configTableRef}></div>
          <button className="ui primary button" onClick={applyConfigChanges}>
            <i className="ui save icon"></i> Aplicar
          </button>
        </div>
      )}
    </div>
  );
};

export default GatewayTable;
